export const GET_SERVICE_LIST = "GET_SERVICE_LIST";
export const GET_SERVICE_LIST_SUCCESS = "GET_SERVICE_LIST_SUCCESS";
export const GET_SERVICE_LIST_FAIL = "GET_SERVICE_LIST_FAIL";

export const POST_ADD_SERVICE = "POST_ADD_SERVICE";
export const POST_ADD_SERVICE_SUCCESS = "POST_ADD_SERVICE_SUCCESS";
export const POST_ADD_SERVICE_FAIL = "POST_ADD_SERVICE_FAIL";

export const GET_AVAILABLE_SERVICES = "GET_AVAILABLE_SERVICES";
export const GET_AVAILABLE_SERVICES_SUCCESS = "GET_AVAILABLE_SERVICES_SUCCESS";
export const GET_AVAILABLE_SERVICES_FAIL = "GET_AVAILABLE_SERVICES_FAIL";

export const POST_UPDATE_SERVICES = "POST_UPDATE_SERVICES";
export const POST_UPDATE_SERVICES_SUCCESS = "POST_UPDATE_SERVICES_SUCCESS";
export const POST_UPDATE_SERVICES_FAIL = "POST_UPDATE_SERVICES_FAIL";

export const GET_SERVICE_ID = "GET_SERVICE_ID";
export const GET_SERVICE_ID_SUCCESS = "GET_SERVICE_ID_SUCCESS";
export const GET_SERVICE_ID_FAIL = "GET_SERVICE_ID_FAIL";

export const POST_DELETE_SERVICE = "POST_DELETE_SERVICE";
export const POST_DELETE_SERVICE_SUCCESS = "POST_DELETE_SERVICE_SUCCESS";
export const POST_DELETE_SERVICE_FAIL = "POST_DELETE_SERVICE_FAIL";

export const GET_ACTIVE_SERVICES = "GET_ACTIVE_SERVICES";
export const GET_ACTIVE_SERVICES_SUCCESS = "GET_ACTIVE_SERVICES_SUCCESS";
export const GET_ACTIVE_SERVICES_FAIL = "GET_ACTIVE_SERVICES_FAIL";

export const POST_TIME_ZONE = "POST_TIME_ZONE";
export const POST_TIME_ZONE_SUCCESS = "POST_TIME_ZONE_SUCCESS";
export const POST_TIME_ZONE_FAIL = "POST_TIME_ZONE_FAIL";
